import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/login", { replace: true }); return; }
      try {
        const u = await googleSession(sid);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(u.onboarded ? "/home" : "/onboarding", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [googleSession, navigate, location.hash]);

  return <div className="min-h-screen bg-background"><Spinner label="Signing you in…" /></div>;
}
